module.exports = __webpack_public_path__ + "static/media/1008893.0d64601b.png";